import { ajax as request } from '@blade/common';
export const getAKSK = () => request({
    url: '/api/user-management/api/v1/accesskey/query',
    method: 'GET',
});
export const updateSK = (data) => request({
    url: '/api/user-management/api/v1/accesskey/modify',
    method: 'POST',
    data,
});
